<template>
    <div class="app">
        <AppHeader fixed>
            <SidebarToggler class="d-lg-none" display="md" mobile />
            <b-link class="navbar-brand" to="#">
                <img class="navbar-brand-full" :src="'/img/brand/logo.svg'" width="89" height="25" alt="CoreUI Logo">
                <img class="navbar-brand-minimized" :src="'/img/brand/sygnet.svg'" width="30" height="30" alt="CoreUI Logo">
            </b-link>
            <SidebarToggler class="d-md-down-none" display="lg" />
            <b-navbar-nav class="d-md-down-none">
                <b-nav-item class="px-3" to="/">ទំព័រដើម</b-nav-item>
            </b-navbar-nav>
            <b-navbar-nav class="ml-auto">
                <DefaultHeaderDropdownAccnt/>
            </b-navbar-nav>
        </AppHeader>
        <div class="app-body">
            <AppSidebar fixed>
                <SidebarNav :navItems="nav"></SidebarNav>
            </AppSidebar>
            <main class="main">
                <router-view></router-view>
            </main>
            <AppAside fixed>
                <DefaultAside/>
            </AppAside>
        </div>
        <TheFooter>
            <div>
                <a href="https://www.khlearners.com">Khmer Learners</a>
                <span class="ml-1">&copy; 2018.</span>
            </div>
            <div class="ml-auto">
                <span class="mr-1">Powered by</span>
                <a href="https://www.khlearners.com">Khmer Learners</a>
            </div>
        </TheFooter>
    </div>
</template>
<script>
    import nav from '@/syssidebar.js'
    const AppHeader = () => import('@/views/layouts/Header.vue');
    const SidebarToggler = () => import('@/views/layouts/SidebarToggler.vue');
    const DefaultHeaderDropdownAccnt = () => import('./DefaultHeaderDropdownAccnt.vue');
    const TheFooter = () => import('@/views/layouts/Footer.vue');
    const AppAside = () => import('@/views/layouts/Aside.vue');
    const DefaultAside = () => import('./DefaultAside');
    import AppSidebar from '@/views/Sidebar/Sidebar';
    import SidebarNav from '@/views/Sidebar/SidebarNav';
    export default {
        name: 'DefaultContainer',
        components: {
            AppHeader,
            SidebarToggler,
            DefaultHeaderDropdownAccnt,
            TheFooter,
            AppAside,
            DefaultAside,
            AppSidebar,
            SidebarNav
        },
        data () {
            return {
                nav: nav.items
            }
        },
        computed: {
            name () {
                return this.$route.name
            },
            list () {
                return this.$route.matched.filter((route) => route.name || route.meta.label )
            }
        }
    }
</script>
<style scoped>
    .main .container-fluid{
        padding: 0 20px;
    }
</style>
